module.exports = __webpack_public_path__ + "static/img/houshi.82f0346a.png";